/*export const sellerIdGet = () => {
  return {
    type: "sellerId",
    payload: { seller_id: "salud" },
  };
};*/

export const CreateHeadersApiGetnet = (headers) => {
  return {
    type: "createHeader",
    payload: headers,
  };
};

export const SaveDataClientGetNet = (data) => {
  return {
    type: "saveDadosCliente",
    payload: data,
  };
};
